const buttonTrigger = document.querySelector('.countdown-box__button');
const arrButtonTrigger = Array.from(document.querySelectorAll('.countdown-box__button'));

if (arrButtonTrigger.length) {
    arrButtonTrigger.forEach((element)=> {
        element.addEventListener("click", () => {
            window._klOnsite = window._klOnsite || [];
            // window._klOnsite.push(['openForm', 'VPHaur']);

            if (window.innerWidth >= 760) {
                const desktopID = element.getAttribute('data-desktop-id');
                window._klOnsite.push(['openForm', desktopID]);
                // window.__attentive.trigger(null, null, null, desktopID);
            } else {
                const mobileID = element.getAttribute('data-mobile-id');
                window._klOnsite.push(['openForm', mobileID]);
                // window.__attentive.trigger(null, null, null, mobileID);
            }
        });
    });
}